import { createFileRoute, notFound } from "@tanstack/react-router";
import NotFound from "@/pages/NotFound";
import { buildRouteHead } from "@/lib/route-head";

export const Route = createFileRoute("/$")({
  // Ohne echten 404-Status werten Google & Co. die Seite als Soft-404.
  loader: () => {
    throw notFound();
  },
  head: () =>
    buildRouteHead({
      title: "404 | Seite nicht gefunden – Enno & Jens",
      description:
        "Die angeforderte Seite wurde nicht gefunden. Zur Startseite der Agentur Enno & Jens in Wernigerode.",
      path: "/",
      noIndex: true,
    }),
  notFoundComponent: NotFound,
  component: NotFound,
});
